// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import BinaryLerpSource from '../../animationpack/blendtree/BinaryLerpSource';

/**
 * A layer blender that uses linear interpolation to merge the results of two layers.
 */
class LayerLerpBlender {
 constructor() {
   this._blendWeight = null;
   this._layerA = null;
   this._layerB = null;
 }

 /**
  * @returns a key-value map representing the blended data from both animation layers.
  */
 getBlendedSourceData() {
   // grab our data maps from the two layers...
   // set A
   const sourceAData = this._layerA.getCurrentSourceData();
   // set B
   const sourceBData = this._layerB._currentState ? this._layerB._currentState.getCurrentSourceData() : null;

   return BinaryLerpSource.combineSourceData(sourceAData, sourceBData, this._blendWeight, null, this._layerB._layerType === "Additive");
 }
}

export default LayerLerpBlender;
